export const coreMobilePt = {

    TOAST: {
        DISPENSAR: "Dispensar",
        AGUARDE: "Aguarde"
    },
    COMMON: {
        CLOSE: "Fechar",
        INPUTIMAGE: {
            GALLERY: "Upload da galeria",
            CAMERA: "Camera"
          },
          OPTIONAL: "Opcional",
          CANCEL: "Cancelar",
          CONFIRM: "Confirmar"
    }

}